import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import "../../styles/css/ElevationForm/elevationForm.css";

class TabComponents extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { stepValue } = this.props;

    return (
      <div>
        <div className="tab-container">
          {stepValue === 1 ? (
            <div>
              <div className="tab-icon">
                <span className="top-icon">
                  <img
                    alt=""
                    src="/static/images/icons/activeIcons/Group-1632@3x.png"
                  />
                </span>
              </div>
              <label>SECTION A</label>
            </div>
          ) : (
            <div>
              <div className="tab-icon-highlight">
                <span className="top-icon-highlight">
                  <img alt="" src="/static/images/icons/sectionA.png" />
                </span>
              </div>
              <label className="active">SECTION A</label>
            </div>
          )}
          {stepValue === 1 ? (
            <div>
              <div className="tab-icon">
                <span className="top-icon">
                  <img alt="" src="/static/images/icons/Group 1619@3x.png" />
                </span>
              </div>
              <label>SECTION B</label>
            </div>
          ) : stepValue === 2 ? (
            <div>
              <div className="tab-icon">
                <span className="top-icon">
                  <img
                    alt=""
                    src="/static/images/icons/activeIcons/Group-1633@3x.png"
                  />
                </span>
              </div>
              <label>SECTION B</label>
            </div>
          ) : stepValue === 3 ||
            stepValue === 4 ||
            stepValue === 5 ||
            stepValue === 6 ||
            stepValue === 7 ||
            stepValue === 8 ||
            stepValue === 9 ? (
            <div>
              <div className="tab-icon-highlight">
                <span className="top-icon-highlight">
                  <img alt="" src="/static/images/icons/sectionB.png" />
                </span>
              </div>
              <label className="active">SECTION B</label>
            </div>
          ) : null}
          {stepValue === 1 || stepValue === 2 ? (
            <div>
              {" "}
              <div className="tab-icon">
                <span className="top-icon">
                  <img alt="" src="/static/images/icons/Group 1620@3x.png" />
                </span>
              </div>
              <label>SECTION C</label>
            </div>
          ) : stepValue === 3 ? (
            <div>
              {" "}
              <div className="tab-icon">
                <span className="top-icon">
                  <img
                    alt=""
                    src="/static/images/icons/activeIcons/Group-1634@3x.png"
                  />
                </span>
              </div>
              <label>SECTION C</label>
            </div>
          ) : stepValue === 4 ||
            stepValue === 5 ||
            stepValue === 6 ||
            stepValue === 7 ||
            stepValue === 8 ||
            stepValue === 9 ? (
            <div>
              <div className="tab-icon-highlight">
                <span className="top-icon-highlight">
                  <img alt="" src="/static/images/icons/sectionC.png" />
                </span>
              </div>
              <label className="active">SECTION C</label>
            </div>
          ) : null}
          {stepValue === 1 || stepValue === 2 || stepValue === 3 ? (
            <div>
              {" "}
              <div className="tab-icon">
                <span className="top-icon">
                  <img alt="" src="/static/images/icons/Group 1621@3x.png" />
                </span>
              </div>
              <label>SECTION D</label>
            </div>
          ) : stepValue === 4 ? (
            <div>
              {" "}
              <div className="tab-icon">
                <span className="top-icon">
                  <img
                    alt=""
                    src="/static/images/icons/activeIcons/Group-1635@3x.png"
                  />
                </span>
              </div>
              <label>SECTION D</label>
            </div>
          ) : stepValue === 5 ||
            stepValue === 6 ||
            stepValue === 7 ||
            stepValue === 8 ||
            stepValue === 9 ? (
            <div>
              <div className="tab-icon-highlight">
                <span className="top-icon-highlight">
                  <img alt="" src="/static/images/icons/sectionD.png" />
                </span>
              </div>
              <label className="active">SECTION D</label>
            </div>
          ) : null}
          {stepValue === 1 ||
          stepValue === 2 ||
          stepValue === 3 ||
          stepValue === 4 ? (
            <div>
              {" "}
              <div className="tab-icon">
                <span className="top-icon">
                  <img alt="" src="/static/images/icons/Group 1622@3x.png" />
                </span>
              </div>
              <label>SECTION E</label>
            </div>
          ) : stepValue === 5 ? (
            <div>
              {" "}
              <div className="tab-icon">
                <span className="top-icon">
                  <img
                    alt=""
                    src="/static/images/icons/activeIcons/Group-1636@3x.png"
                  />
                </span>
              </div>
              <label>SECTION E</label>
            </div>
          ) : stepValue === 6 ||
            stepValue === 7 ||
            stepValue === 8 ||
            stepValue === 9 ? (
            <div>
              <div className="tab-icon-highlight">
                <span className="top-icon-highlight">
                  <img alt="" src="/static/images/icons/sectionE.png" />
                </span>
              </div>
              <label className="active">SECTION E</label>
            </div>
          ) : null}
          {stepValue === 1 ||
          stepValue === 2 ||
          stepValue === 3 ||
          stepValue === 4 ||
          stepValue === 5 ? (
            <div>
              {" "}
              <div className="tab-icon">
                <span className="top-icon">
                  <img alt="" src="/static/images/icons/Group 1623@3x.png" />
                </span>
              </div>
              <label>SECTION F</label>
            </div>
          ) : stepValue === 6 ? (
            <div>
              {" "}
              <div className="tab-icon">
                <span className="top-icon">
                  <img
                    alt=""
                    src="/static/images/icons/activeIcons/Group-1637@3x.png"
                  />
                </span>
              </div>
              <label>SECTION F</label>
            </div>
          ) : stepValue === 7 || stepValue === 8 || stepValue === 9 ? (
            <div>
              <div className="tab-icon-highlight">
                <span className="top-icon-highlight">
                  <img alt="" src="/static/images/icons/sectionF.png" />
                </span>
              </div>
              <label className="active">SECTION F</label>
            </div>
          ) : null}
          {stepValue === 1 ||
          stepValue === 2 ||
          stepValue === 3 ||
          stepValue === 4 ||
          stepValue === 5 ||
          stepValue === 6 ? (
            <div>
              {" "}
              <div className="tab-icon">
                <span className="top-icon">
                  <img alt="" src="/static/images/icons/Group 1624@3x.png" />
                </span>
              </div>
              <label>SECTION G</label>
            </div>
          ) : stepValue === 7 ? (
            <div>
              {" "}
              <div className="tab-icon">
                <span className="top-icon">
                  <img
                    alt=""
                    src="/static/images/icons/activeIcons/Group-1638@3x.png"
                  />
                </span>
              </div>
              <label>SECTION G</label>
            </div>
          ) : stepValue === 8 || stepValue === 9 ? (
            <div>
              <div className="tab-icon-highlight">
                <span className="top-icon-highlight">
                  <img alt="" src="/static/images/icons/meeting.png" />
                </span>
              </div>
              <label className="active">SECTION G</label>
            </div>
          ) : null}
          {stepValue === 1 ||
          stepValue === 2 ||
          stepValue === 3 ||
          stepValue === 4 ||
          stepValue === 5 ||
          stepValue === 6 ||
          stepValue === 7 ? (
            <div>
              {" "}
              <div className="tab-icon">
                <span className="top-icon">
                  <img alt="" src="/static/images/icons/Group 1625@3x.png" />
                </span>
              </div>
              <label>PHOTOGRAPHS</label>
            </div>
          ) : stepValue === 8 ? (
            <div>
              {" "}
              <div className="tab-icon">
                <span className="top-icon">
                  <img
                    alt=""
                    src="/static/images/icons/activeIcons/Group-1639@3x.png"
                  />
                </span>
              </div>
              <label>PHOTOGRAPHS</label>
            </div>
          ) : stepValue === 9 ? (
            <div>
              <div className="tab-icon-highlight">
                <span className="top-icon-highlight">
                  <img alt="" src="/static/images/icons/sectionH.png" />
                </span>
              </div>
              <label className="active">PHOTOGRAPHS</label>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default TabComponents;



// WEBPACK FOOTER //
// ./src/pages/ElevationForm/TabComponents.js